import { AfterViewInit, Component, inject, OnDestroy, OnInit, signal } from "@angular/core";
import { Router, NavigationEnd, RouterModule } from "@angular/router";
import { UserService } from "@company-box/services";
import { filter } from "rxjs/operators";
import { Subscription } from "rxjs";
import { NavigationService } from "projects/cb-ui/src/app/services/navigation.service";

@Component({
  selector: "app-nav-top",
  templateUrl: "./nav-top.component.html",
  styleUrls: ["./nav-top.component.scss"],
  imports: [RouterModule],
})
export class NavTopComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  step = signal<number>(-1);

  private userService: UserService = inject(UserService);
  private router: Router = inject(Router);
  private navigationService: NavigationService = inject(NavigationService);

  constructor() {
        this.subscription.add(
          this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
              this.resetSteps();
              if (event.url.includes("continue-project") || event.url.includes("start")) {
                this.step.set(1);
              } else if (event.url.includes("box-category") || event.url.includes("box-style")) {
                this.step.set(2);
              } else if (event.url.includes("box-options")) {
                this.step.set(3);
              } else if (event.url.includes("design") && !event.url.includes("services")) {
                this.step.set(4);
              } else if (event.url.includes("review-box")) {
                this.step.set(5);
              } else if (event.url.includes("cart")) {
                this.step.set(6);
              }
            })
        );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {

  }

  ngOnInit() {

  }

  resetSteps() {
    this.step.set(-1);
  }

  logout() {
    this.userService.logout().then(() => {
      window.location.reload();
    });
  }

  goToBoxCategories() {
    if (this.step() > 2) {
      this.router.navigate(["/box-category", { upload: this.navigationService.getIsUpload() }]);
    }
  }

  goToBoxOptions() {
    if (this.step() > 3) {
      this.router.navigate([
        "/box-options",
        this.navigationService.getCategory(),
        this.navigationService.getSubcategory(),
        this.navigationService.getIsUpload(),
      ]);
    }
  }

  goToDesigner() {
    if (this.step() > 4 ) {
      this.router.navigate([
        "/design",
        this.navigationService.getCategory(),
        this.navigationService.getSubcategory(),
        this.navigationService.getProductDetails(),
      ]);
    }
  }
}
